import React, {useContext, useState, useEffect} from 'react';
import { FormContext } from '../../Pages/Apply'
import * as Yup from 'yup';
import {Formik, Form} from 'formik';
import SelectControl from '../SelectControl'
import TextboxControl from '../TextboxControl';
import {AuthContext} from '../../context/AuthContext'


const EligibilityCheck = (props) => {
  const {userInfo} = useContext(AuthContext);

    const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);
    const [stepData, setStepData]= useState({passingYear: '', totalMarks: '', obtainedMarks: '', matricPercent: '',  physicsTotal: '', physicsObtained: '', chemistryTotal: '', chemistryObtained: '', biologyTotal: '',  biologyObtained: '', scienceSubjectsTotal: '', scienceSubjectsObtained: '', scienceSubjectsPercent: ''})


  const validationScheme = Yup.object().shape({
    passingYear: Yup.number("Must be number").required("Required").integer("Should be whole number").positive("Must be a positive value").max(userInfo.year, `Only those Students are eligible who pass martic till ${userInfo.year}` ),
    totalMarks: Yup.string().required("Required"),
    obtainedMarks: Yup.number("Must be number").required("Required").integer("Should be whole number").positive("Must be a positive value").max(Yup.ref('totalMarks'), "Cannot Exceed Maximum Marks"),
    matricPercent: Yup.number("Must be number").required("Required").min(45, 'Minimum 45% required'),
    physicsTotal: Yup.string().required("Required"),
    physicsObtained: Yup.number("Must be number").required("Required").integer("Should be whole number").positive("Must be a positive value").max(Yup.ref('physicsTotal'), "Cannot Exceed Physics Total Marks"),
    chemistryTotal: Yup.string().required("Required"),
    chemistryObtained: Yup.number("Must be number").required("Required").integer("Should be whole number").positive("Must be a positive value").max(Yup.ref('chemistryTotal'), "Cannot Exceed Chemistry  Total Marks"),
    biologyTotal: Yup.string().required("Required"),
    biologyObtained: Yup.number("Must be number").required("Required").integer("Should be whole number").positive("Must be a positive value").max(Yup.ref('biologyTotal'), "Cannot Exceed Biology Total Marks"),
    scienceSubjectsTotal: Yup.string().required("Required"),
    scienceSubjectsObtained: Yup.string().required("Required"),
    scienceSubjectsPercent: Yup.number("Must be number").required("Required").min(45, 'Minimum 45% required'),
  })

  const goToPreviousStep = () => {
    setActiveStepIndex(activeStepIndex - 1);
}

  const calculateOverallPercentage = async (e, form) => {
    var obtainedMarks = form.values.obtainedMarks != ""  ? parseInt(form.values.obtainedMarks) : 0;
    var totalMarks = form.values.totalMarks != ""  ? parseInt(form.values.totalMarks) : 0;
    if (totalMarks === 0)
    {
        form.setFieldValue('matricPercent', '');
    }
    else
    {
        var overallPercent = ((obtainedMarks / totalMarks) * 100).toFixed(2);
        form.setFieldValue('matricPercent', overallPercent);
    }
    await form.validateForm();
    //form.validateField('obtainedMarks');
  }


  const calculatScienceSubjectsPercentage = async (event, form) => {
    var physicsTotal = form.values.physicsTotal != "" ? parseInt(form.values.physicsTotal) : 0;
    var physicsObtained = form.values.physicsObtained != ""  ? parseInt(form.values.physicsObtained) : 0;
    var chemistryTotal = form.values.chemistryTotal != ""  ? parseInt(form.values.chemistryTotal) : 0;
    var chemistryObtained = form.values.chemistryObtained != ""  ? parseInt(form.values.chemistryObtained) : 0;
    var biologyTotal = form.values.biologyTotal != ""  ? parseInt(form.values.biologyTotal) : 0;
    var biologyObtained = form.values.biologyObtained != "" ? parseInt(form.values.biologyObtained) : 0;
    
    await form.validateForm();
    //form.validateField('physicsObtained');
    //form.validateField('chemistryObtained');
    //form.validateField('biologyObtained');
    
    var scienceSubjectsTotal = physicsTotal + chemistryTotal + biologyTotal;
    var scienceSubjectsObtained = physicsObtained + chemistryObtained + biologyObtained;   
    
    form.setFieldValue('scienceSubjectsTotal', scienceSubjectsTotal);
    form.setFieldValue('scienceSubjectsObtained', scienceSubjectsObtained);
    
    if (physicsTotal === 0 || chemistryTotal === 0 || biologyTotal === 0 )
    {
        form.setFieldValue('scienceSubjectsPercent', '');
    }
    else
    {
        var scienceSubjectsPercent = ((scienceSubjectsObtained / scienceSubjectsTotal) * 100).toFixed(2);
        form.setFieldValue('scienceSubjectsPercent', scienceSubjectsPercent);
    }
  }

  useEffect(() => {
    setStepData((prevState) => ({
      ...prevState,
      ...formData,
    }));

    
}, []);

   const submit = async (values, { setSubmitting }) => {
    const data = { ...formData, ...values };
    setFormData(data);
    setSubmitting(false);
    setActiveStepIndex(activeStepIndex + 1);        
  }
   


  return (
    <>
        <div className="">

           <Formik initialValues={stepData} validationSchema={validationScheme} onSubmit={submit} enableReinitialize={true} >
             {formik => (

               <Form style={{padding: '50px', paddingBottom: '10px'}} className='row g-3'>

              <div className='mb-3 col-12'>
                  <p class="mb-4 text-uppercase fs-5 fw-bold">Eligibility Criteria  (Matric)</p>
              </div>

                <div className='col-12'>
                    <TextboxControl  label="Passing Year"  className="form-control" name="passingYear"  type="text" placeholder="Passing Year" />                    
                </div>


                <h6>Marks in Matric</h6>

                <div className='col-md-4'>
                    <SelectControl label="Total Marks"  className="form-control" name="totalMarks"  placeholder="Total Marks" onBlurCapture={(e) => {calculateOverallPercentage(e, formik)}}>
                    <option value="">---</option>
                    <option value="1100">1100</option>
                    <option value="1050">1050</option>
                    <option value="850">850</option>
                    <option value="900">900</option>
                    <option value="1000">1000</option>
                    <option value="1200">1200</option>
                    </SelectControl>                    
                </div>
                <div className='col-md-4'>
                  <TextboxControl  label="Obtained Marks"  className="form-control" name="obtainedMarks"  type="text" placeholder="Obtained Marks"  onBlurCapture={(e) => {  calculateOverallPercentage(e, formik)}} />                              
                </div>
                <div className='col-md-4'>
                  <TextboxControl  label="Matric Marks %"  className={`form-control ${formik.getFieldProps("matricPercent").value >= 45  ? "is-valid" : "is-invalid"}`} name="matricPercent"  type="text" placeholder="Matric Marks %" readonly="readonly" />                              
                </div>

                <h6>Marks in Science Subjects</h6>

                <div className='col-md-6'>
                    <SelectControl label="Physics Total Marks"  className="form-control" name="physicsTotal"  placeholder="Physics Total Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}>
                    <option value="">---</option>
                    <option value="150">150</option>
                    <option value="100">100</option>
                    </SelectControl>                    
                </div>
                <div className='col-md-6'>
                  <TextboxControl  label="Physics Obtained Marks"  className="form-control" name="physicsObtained"  type="text" placeholder="Physics Obtained Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}/>                              
                </div>

                <div className='col-md-6'>
                    <SelectControl label="Chemistry Total Marks"  className="form-control" name="chemistryTotal"  placeholder="Chemistry Total Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}>
                    <option value="">---</option>
                    <option value="150">150</option>
                    <option value="100">100</option>
                    </SelectControl>                    
                </div>
                <div className='col-md-6'>
                  <TextboxControl  label="Chemistry Obtained Marks"  className="form-control" name="chemistryObtained"  type="text" placeholder="Chemistry Obtained Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}/>                              
                </div>

                <div className='col-md-6'>
                    <SelectControl label="Biology Total Marks"  className="form-control" name="biologyTotal"  placeholder="Biology Total Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}>
                    <option value="">---</option>
                    <option value="150">150</option>
                    <option value="100">100</option>
                    </SelectControl>                    
                </div>
                <div className='col-md-6'>
                  <TextboxControl  label="Biology Obtained Marks"  className="form-control" name="biologyObtained"  type="text" placeholder="Biology Obtained Marks" onBlurCapture={(e) => {calculatScienceSubjectsPercentage(e, formik)}}/>                              
                </div>

                <h6>Science Subjects Summary</h6>
                <div className='col-md-4'>
                  <TextboxControl  label="Science Subjects Total Marks"  className="form-control" name="scienceSubjectsTotal"  type="text" placeholder="Science Subjects Total Marks" readonly="readonly" />                              
                </div>

                <div className='col-md-4'>
                  <TextboxControl  label="Science Subjects Obtained Marks"  className="form-control" name="scienceSubjectsObtained"  type="text" placeholder="Science Subjects Obtained Marks" readonly="readonly" />                              
                </div>

                <div className='col-md-4'>
                  <TextboxControl  label="Science Subjects %"  className={`form-control ${formik.getFieldProps("scienceSubjectsPercent").value >= 45  ? "is-valid" : "is-invalid"}`}  name="scienceSubjectsPercent"  type="text" placeholder="Science Subjects %" readonly="readonly" />                              
                </div>

                <div className="d-flex justify-content-between gap-4 pb-3 pt-4">
                    <button className="btn btn-secondary w-50" type="button" onClick={goToPreviousStep}> Previous </button>

                    <button className="btn btn-primary w-50" type="submit" disabled={!(formik.isValid ) || formik.isSubmitting}>
                    {formik.isSubmitting ? 
                    (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : 
                    (<span >Next</span>)
                        }
                    </button>
                </div>
               </Form>
             )}
           </Formik>      
       </div> 

 
    </>
  );

};

export default EligibilityCheck;
